import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-wall-page-sidebar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NButton, {
      onClick: _ctx.dispatchCloseEvent,
      class: "video-wall-page-sidebar__close",
      icon: "close",
      type: "text"
    }, null, 8, ["onClick"]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}